const HR_MANAGER_SITE_COOKIE_NAME = "hr-manager-site";

module.exports = {
  HR_MANAGER_SITE_COOKIE_NAME
};
